import captureError from '@disco/utils/captureError'
// Navigation handled through window.location for middleware
import type { Middleware } from 'types/redux'
import api from '@disco/api/server'
import Intercom from '@disco/api/intercom'
const message403 = 'Authentication credentials were not provided.'

const tokenExpirer: Middleware =
  () =>
  (next: (...args: Array<any>) => any) =>
  (action: Record<string, any>) => {
    const { error } = action
    if (!error) return next(action)
    const errorContainsAuthError =
      (error.message && error.message.indexOf(message403) > -1) ||
      (error.body &&
        error.body.detail &&
        error.body.detail.indexOf(message403) > -1)
    const expiredSession =
      error &&
      ((error.status === 403 && errorContainsAuthError) || error.status === 401)

    // log 403 message that's not tied to token expiration
    if (error && error.status === 403 && !expiredSession) {
      captureError(error, {
        description: 'User encountered 403 error',
        extra: { level: 'info' },
      })
    }

    const { pathname } = window.location

    if (
      expiredSession &&
      pathname !== '/login' &&
      !pathname.startsWith('/upload/')
    ) {
      api.resetBrowserInstanceId()
      // The reload below unloads Intercom before /logout can shut it down.
      Intercom.shutdown()
      window.location.href = '/logout?sessionExpired=1'
      return next(action)
    }

    return next(action)
  }

export default tokenExpirer
